import { render, staticRenderFns } from "./issuable_tabs.vue.js?vue&type=template&id=dbf827f2!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_tabs.vue?vue&type=template&id=dbf827f2"
import script from "./issuable_tabs.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_tabs.vue?vue&type=script&lang=js"
export * from "./issuable_tabs.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issuable_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports